import { DateTime } from 'luxon'

export class JsonWebTokenError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'JsonWebTokenError'
  }
}

export class TokenExpiredError extends Error {
  expiredAt: Date
  constructor(message: string, expiredAt: Date) {
    super(message)
    this.name = 'TokenExpiredError'
    this.expiredAt = expiredAt
  }
}

const decodePayload = (token: string): Record<string, unknown> => {
  const parts = token.split('.')
  if (parts.length !== 3) {
    throw new JsonWebTokenError('Invalid token')
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(atob(base64)) as Record<string, unknown>
  } catch {
    throw new JsonWebTokenError('Invalid token')
  }
}

export const decodeTestModeToken = (token: string) => {
  const payload = decodePayload(token)

  if (typeof payload.exp !== 'number') {
    throw new JsonWebTokenError('invalid exp value')
  }

  if (
    typeof payload.type !== 'string' ||
    payload.type !== 'application_environment_test_mode'
  ) {
    throw new JsonWebTokenError('invalid type value')
  }

  const clockTimestamp = Math.floor(Date.now() / 1000)
  if (clockTimestamp >= payload.exp) {
    throw new TokenExpiredError('jwt expired', new Date(payload.exp * 1000))
  }

  return {
    expires: DateTime.fromSeconds(payload.exp),
  }
}
